module.exports = __webpack_public_path__ + "img/Hypoxia-BRCA_10X_DCIS.239a64b1.png";